// App.js
import React from "react";
import InventoryApp from "./components/website/website";

function App() {
  return (
    <>
      <InventoryApp />
    </>
  );
}

export default App;
